import React from "react";
import { Modal, Button } from "react-bootstrap";
import useApi from "../../hook/useAPI";
import { USER_MANAGEMENT } from "../../utils/const";
import { toast } from "react-toastify";

const UserStatusModal = ({ show, handleClose, userId, currentStatus, onStatusUpdated }) => {
  const { putData } = useApi();

  const handleConfirm = async () => {
    try {
      const newStatus = currentStatus === "active" ? "inactive" : "active";
      const response = await putData(`${USER_MANAGEMENT.UPDATE_USER}?id=${userId ? `${userId}` : ""}`, { status: newStatus });
      if (response.status) {
        onStatusUpdated(newStatus);
        handleClose();
        toast.success("User updating status successfully");

      } else {
        console.error("Error updating user status:", response.message);
      }
    } catch (error) {
      console.error("Error updating user status:", error);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="md" className="bs_common_modal user-status-modal">
      <Modal.Header closeButton>
        <Modal.Title>User Status</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="dialog-content-body">
          Are you sure you want to <b>{currentStatus === "active" ? "inactivate" : "activate"}</b> this user?
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserStatusModal;
